import PackageJson from "../../package.json";

export const name = PackageJson.name;
export const version = PackageJson.version;

// Production Server
export const baseURL = "https://aylar.pythonanywhere.com";

// Dev Server
// export const baseURL = "http://127.0.0.1:8000";
